import UnAuthroziedPageImg from "../../assests/images/errorHandler/unAuthroziedPage.webp"
import { useRouteMatch, useHistory } from "react-router-dom";

import { getData } from '../../utils/AsyncStorage'


const UnAuthroziedPage = () => {
  const { role, id ,first_name} = JSON.parse(getData("userInfo") || 0);

    const history = useHistory();
    const moveToRoot = () => {
      role === 3 && first_name === null ?
     history.push("/createProfile") :
        history?.goBack()
      };

    return (
        <div class="full-container p-0 d-flex flex-column  ">
            <div class="col-lg-12 mb-4 ">
            <nav class="navbar navbar-light navStyle  p-0 mb-4 ">
              <div class="mx-2">
                <i class="bi bi-list fs-2 text-white"></i>
              </div>
              <ul class="nav justify-content-center align-items-center ms-auto">
                <li class="nav-item mx-2">
                  <i class="bi bi-bell fs-4 text-white"></i>
                </li>
                <li class="nav-item mx-2">
                  <h1 class="text-white fs-5 m-0">Hi!</h1>
                </li>
                <li class="nav-item mx-2">
                <i class="bi bi-person-circle fs-2 text-white"></i>
                </li>
              </ul>

            </nav>
          </div>
            <div class="col-lg-12 d-flex flex-1  flex-column justify-content-center align-items-center" >
                <div class="d-flex flex-row align-self-center">
                       <img src={UnAuthroziedPageImg} alt="unAuthroziedPage" />
                       <div class="my-3">
                       <h1 class="roboto fw-bold text-center">Unauthorized Access</h1>
                       <p class="roboto fs-4">Sorry! But you are not authorized to access this page.</p>
                       </div>
                
                </div>
                <div class="d-flex  my-1 align-self-center mb-4">
                    <button onClick={() => moveToRoot()} variant="contained" class="primaryButton ">
                     Go Back
                        </button>
                     </div>
                
            </div>
        </div>

    )
}


export default UnAuthroziedPage